import React, { useEffect, useState } from 'react';

import LotteriesApi from '../../../Api/CRM/Modules/LotteriesApi';
import FormFileGroup from '../../elements/formElements/FormFileGroup';
import FormGroup from '../../elements/formElements/FormGroup';
import Select, { SelectOptions } from '../../elements/formElements/Select';

import useOnce from '../../hooks/useOnce';

import SliderItem from 'Api/Models/SliderItem';
import useGlobalState from 'crm/GlobalStateContext';
import SubmitButton from 'crm/elements/formElements/SubmitButton';
import { ValidationErrors } from 'crm/helpers/ResponseErrorHelper';

type Props = Readonly<{
    action: (sliderItem: SliderItem) => unknown;
    errors: ValidationErrors;
    updatedSliderItem?: SliderItem;
}>;

function SliderItemForm({ action, errors, updatedSliderItem }: Props) {
    const { languages, languageNames } = useGlobalState();
    const [sliderItem, setSliderItem] = useState<SliderItem>(new SliderItem({}));

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        action(sliderItem);
    };

    const getErrorFor = (field: string): string => errors?.[field]?.[0];

    const [lotteryNames, setLotteryNames] = useState<SelectOptions>({});
    useOnce(() => LotteriesApi.getNames().then(setLotteryNames));
    useEffect(() => {
        if (!updatedSliderItem && languages.length > 0) {
            setSliderItem((prev) => prev.getNew({ language_id: languages[0].id }));
        }
    }, [languageNames]);

    useEffect(() => {
        if (updatedSliderItem) {
            setSliderItem(updatedSliderItem);
        }
    }, [updatedSliderItem]);

    return (
        <form onSubmit={handleSubmit} autoComplete="do-not-autofill" encType="multipart/form-data">
            <Select
                error={getErrorFor('language_id')}
                field="language_id"
                value={sliderItem.language_id}
                label="For Language"
                options={languageNames}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ language_id: parseInt(e.target.value) }))}
                required
            />
            <FormFileGroup
                field="image_url"
                value={sliderItem.image_url}
                label="Slide Image"
                error={getErrorFor('image_url')}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ image_url: e.target.files[0] }))}
            />
            <FormFileGroup
                field="mobile_image_url"
                value={sliderItem.mobile_image_url}
                label="Slide Image - mobile"
                error={getErrorFor('mobile_image_url')}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ mobile_image_url: e.target.files[0] }))}
            />
            <FormGroup
                type="text"
                field="redirection_url"
                value={sliderItem.redirection_url ?? ''}
                label="Redirection Url"
                error={getErrorFor('redirection_url')}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ redirection_url: e.target.value }))}
            />
            <FormGroup
                type="text"
                field="alt_value"
                value={sliderItem.alt_value ?? ''}
                label="Alt value"
                error={getErrorFor('alt_value')}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ alt_value: e.target.value }))}
            />
            <Select
                error={getErrorFor('lottery_id')}
                field="lottery_id"
                value={sliderItem.lottery_id ?? ''}
                label="Choose Lottery"
                options={lotteryNames}
                handleChange={(e) => setSliderItem((prev) => prev.getNew({ lottery_id: parseInt(e.target.value) }))}
            />
            <SubmitButton label="Save" />
        </form>
    );
}

export default SliderItemForm;
